export default "__VITE_ASSET__BJnr1dL6__"